import React from 'react';
import {
  Box,
  Typography,
  CircularProgress,
  Container
} from '@mui/material';
import { useHousehold } from '../../contexts/HouseholdContext';
import { householdSelectorStyles } from './HouseholdSelector.styles';
import { translateHouseholdName, t } from '../../utils/translations';

interface HouseholdSelectorProps {
  show: boolean;
}

const HouseholdSelector: React.FC<HouseholdSelectorProps> = ({ show }) => {
  const {
    households,
    setActiveHousehold,
    isLoading,
  } = useHousehold();

  const activeHouseholds = households.filter(h => h.status === 1);

  const handleHouseholdSelect = (householdId: string) => {
    setActiveHousehold(householdId);
  };

  const getHouseholdColor = (index: number) => {
    const colors = [
      '#e3f2fd', // light blue
      '#f3e5f5', // light purple
      '#e8f5e8', // light green
      '#fff3e0', // light orange
      '#fce4ec', // light pink
      '#f1f8e9', // light lime
    ];
    return colors[index % colors.length];
  };

  if (!show) {
    return null;
  }

  if (isLoading) {
    return (
      <Box sx={householdSelectorStyles.overlay}>
        <Container maxWidth="sm">
          <Box sx={householdSelectorStyles.loadingContainer}>
            <CircularProgress />
            <Typography variant="body1" sx={{ mt: 2 }}>
              {t('householdSelector.loadingHouseholds')}
            </Typography>
          </Box>
        </Container>
      </Box>
    );
  }

  return (
    <Box sx={householdSelectorStyles.overlay}>
      <Container maxWidth="md">
        <Box sx={householdSelectorStyles.pageContainer}>
          <Box sx={householdSelectorStyles.header}>
            <Typography variant="h4" component="h1" align="center">
              {t('householdSelector.title')}
            </Typography>
            <Typography variant="body1" color="text.secondary" align="center" mt={2}>
              {t('householdSelector.subtitle')}
            </Typography>
          </Box>

          <Box sx={householdSelectorStyles.householdGrid}>
            {activeHouseholds.map((household, index) => (
              <Box
                key={household.id}
                sx={{
                  ...householdSelectorStyles.householdCard,
                  backgroundColor: getHouseholdColor(index),
                }}
                onClick={() => handleHouseholdSelect(household.id)}
              >
                <Typography variant="h6" component="h3">
                  {translateHouseholdName(household.name)}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default HouseholdSelector;